<app-loading *ngIf="notificationsLoading$ | async"></app-loading>

<div class="notifications" *ngIf="!(notificationsLoading$ | async)">
  <h5>
    <fa-icon [icon]="['fas', 'flag']"></fa-icon>
    {{ "notifications.title.notifications-center" | translate }}
  </h5>

  <ng-container
    *ngIf="(notifications$ | async)?.length > 0; else noNotifications"
  >
    <app-notification
      *ngFor="let notification of notifications$ | async"
      [notification]="notification"
    ></app-notification>
  </ng-container>
</div>

<ng-template #noNotifications>
  <p class="no-notifications">
    {{ "notifications.message.no-notifications" | translate }}
  </p>
</ng-template>
